import React, { useContext, useEffect, useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Box,
    Button,
    Container,
    Card,
    CardContent,
    useMediaQuery,
    useTheme
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { Getrequest } from '../../../../../../context/AxiosRequest';
import { ContextData } from '../../../../../../context/Context';
import baseUrl from '../../../../../../BaseURL';

const DownloadINDEMNITYFORM = () => {

    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const {accesstoken,UserTokens,ChangeLoanForm} = useContext(ContextData)
    const [filesList,setfilesList] = useState([])
    
    const files = [
        {
            id: 1,
            fileName: 'Indemnity Form',
            description: 'Download this form, fill it out completely, sign it, and upload the scanned copy back to the portal.',
            downloadUrl: '/path-to-file/indemnity.pdf'
        },
        {
            id: 2,
            fileName: 'Declaration Form',
            description: 'Please download, read carefully, sign, and return with all required supporting documents.',
            downloadUrl: '/path-to-file/declaration.pdf'
        },
    ];


      useEffect(()=>{

                       ( async()=>{
                          
                             const response = await Getrequest("/auth/get_uploaded_files_settings",accesstoken)

                                 const filter = response.filter(v => (v.loan_category === ChangeLoanForm))
                               setfilesList(filter)

                       })()   
      },[])

      
const handleDownload = (filename,file_token) => {
    const url = `${baseUrl}/auth/get_downlaod_for_loan_upload/${filename}/${file_token}`;

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

    const MobileView = () => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {filesList.length > 0 && filesList.map((file) => (
                <Card key={file.id} elevation={3}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            {file.file_name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            {file.instructions}
                        </Typography>
                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            onClick={() => handleDownload(file.file_path,file.file_token)}
                            sx={{
                                backgroundColor: '#1976d2',
                                '&:hover': { backgroundColor: '#1565c0' }
                            }}
                        >
                            Download
                        </Button>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );

    const DesktopView = () => (
        <TableContainer component={Paper} elevation={3}>
            <Table sx={{ minWidth: 650 }}>
                <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell sx={{ fontWeight: 'bold' , whiteSpace:"nowrap" }}>File Name</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' , whiteSpace:"nowrap" }}>Loan Category</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' , whiteSpace:"nowrap" }}>Instructions</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' , whiteSpace:"nowrap" }} align="center">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
 
                    {filesList.length > 0 && filesList.map((file) => (
                        <TableRow  key={file.id} sx={{ '&:hover': { backgroundColor: '#fafafa' } }}>
                            <TableCell sx={{whiteSpace:"nowrap"}}>{file.file_name}</TableCell>
                            <TableCell>{file.loan_category}</TableCell>
                            <TableCell>{file.instructions}</TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    startIcon={<DownloadIcon />}
                                    onClick={() => handleDownload(file.file_path,file.file_token)} 
                                    sx={{
                                        backgroundColor: '#1976d2',
                                        '&:hover': { backgroundColor: '#1565c0' }
                                    }}
                                >
                                    Download
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
                Available Documents for Download
            </Typography>
            {isMobile ? <MobileView /> : <DesktopView />}
        </Container>
    );
}

export default DownloadINDEMNITYFORM;
